<template>
  <div :class="{'page-bottom': is_fixed}" style="margin-top:3vw">
    <div class='home_content' v-if="show_bottom_content">
      <div class='home_title'>
        <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
        <p>JOIN SpinX Games</p>
      </div>
      <div class="msg_content">
        <el-image :src="grande_join_bottom" style=" width: 100%; margin-bottom: 3%"></el-image>
      </div>
    </div>
    <div class="new-bottom" v-if="is_pc">
      <img
        src="../assets/img_spin/logo.png"
        alt="Logo"
        style="height: 3.5vw; margin-top: 0.5vw"
      />
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div style="text-align: left;margin-top: 5px">
          <div class="contact-info">CONTACT INFORMATION</div>
          <table>
            <tr>
              <td class="icon-td">
                <i class="el-icon-location-outline" style="color: #f3c258"></i>
              </td>
              <td>
                <span class="location-text">Suite nos. 6B-7, 19 Floor, China Hong Kong City Tower 3,<br> 33 Canton Road, Kowloon, Hong Kong </span>
              </td>
            </tr>
            <tr>
              <td class="icon-td">
                <i class="el-icon-message" style="color: #f3c258"></i>
              </td>
              <td>
                <span class="location-text">careers@spinxgames.com</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="anti">
          <div>For Anti-Fraud query, please contact: ethics@spinxgames.com</div>
          <div class="anti-fraud-i">(please do NOT send game playing related query to this email, we may ignore it)</div>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px">
        <div class="copyright">
          Copyright @ 2018 SpinX Games
        </div>
        <div>
          <a
            @click="showCookieSettings"
            style="color:#8c8b9a;font-weight: 800;text-decoration: underline;font-size: 14px; cursor: pointer"
          >
            Cookie Settings
          </a>
          <span style="margin: 0 10px"> </span>
          <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 14px">
            Responsible Gaming
          </a>
          <span style="margin: 0 10px"> </span>
          <a href="/ethics"  style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 14px">
            Code of Ethics
          </a>
        </div>
      </div>
    </div>
    <div id="bottom" v-else>
      <div style="position: relative;text-align: left;">
        <el-image :src="grande_bottom_img" class="bottom-img"></el-image>
        <div class="anti-fraud">
          <div>For Anti-Fraud query, please contact:</div>
          <div style="text-decoration: underline;">ethics@spinxgames.com</div>
          <div class="anti-fraud-i">(please do NOT send game playing related query to this email, we may ignore it)</div>
        </div>
      </div>
      <div>
        <a
          @click="showCookieSettings"
          href="#"
          style="color:#8c8b9a;font-weight: 800;text-decoration: underline;font-size: 14px; cursor: pointer"
        >
          Cookie Settings
        </a>
      </div>
      <div>
        <a href="https://spinxgames.pactsafe.io/spinx-games#responsible-gaming"  target="_blank" style="color:#8c8b9a;font-weight: 800;text-decoration: revert;">
          Responsible Gaming
        </a>
      </div>
      <div>
        <a href="/ethics"  style="color:#8c8b9a;font-weight: 800;text-decoration: revert;font-size: 14px">
          Code of Ethics
        </a>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  data() {
    return {
      src: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom.png',
      src_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/bottom_en.png',
      text: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text.png',
      text_en: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/msg_text_en.png',
      grande_join_bottom:`${require('../assets/img_spin/joinus_v2.png')}`,
      grande_bottom_img:`${require('../assets/img_spin/spin_bottom_24.png')}`,
      input: ''
    };
  },
  computed: {
    is_pc() {
      return document.documentElement.clientWidth > 992;
    },
    //英文版首页、关于页，内容不足
    is_fixed() {
      const cur_path = this.$route.path.split('/')[1];
      return false;
      // return cur_path === '' && this.$i18n.locale === 'en' ? true : false
    },
    join_bottom() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc.png';
    },
    join_bottom_en() {
      return 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/bottom_pc_en.png';
    },
    isBole() {
      return /bole|localhost/.test(window.location.hostname)
    },
    show_bottom_content() {
      return this.$route.name !== 'associates';
    },
  },
  methods: {
    showCookieSettings() {
      this.$emit('show-cookie-settings')
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../assets/style/colors.less');
.beian {
  font-size: 1.2vw;
  color: white;
  padding-bottom: 20px;
  font-family: auto;
  cursor: pointer;
  a {
    text-decoration:none;
    color: #828181;
  }
}
#bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 0 1vw;
  background: @lanmu;
  position: relative;
}
.bottom-img {
  width: 70%
}
.msg_content {
  width: 100%;
  // padding: 2.5vw 2.2vw;
  // background: @lanmu;
  position: relative;
  overflow: hidden;
  .msg {
    width: 24vw;
    height: 3.5vw;
    margin-top: 1vw;
    background: white;
    display: flex;
    float: right;
    align-items: center;
    overflow: hidden;
    .msg-input {
      position: relative;
      width: 79%;
      float: left;
    }
    .msg-icon {
      float: right;
      margin-right: 1px;
    }
  }
  .msg_content_intro {
    position: relative;
    float: left;
    width: 50%;
    .msg-text {
      width: 70%;
    }
  }
}
.msg-input {
  display: block;
}
.msg-input-mobile {
  display: none;
}
.over {
  overflow:hidden;
}
.msg-icon-img {
  height: 3vw;
  margin-top: 5px;
}
.anti-fraud {
  position: absolute;
  left: 70%;
  top: 0;
  width: 26%;
  text-align: left;
  color: #b9b2e2;
  font-weight: 500;
}
.anti-fraud-i {
  font-style: italic;
  font-size: 13px;
}

@media screen and (max-width: 992px) {
  .anti-fraud {
    font-size: 12px;
    position: relative;
    text-align: center;
    left: 0%;
    width: 100%;
    transform: scale(0.7);
  }
  .beian {
    font-size: 12px;
    padding-bottom:2px;
  }
  .home_title p {
    bottom: 2.3vw;
  }
  .home-title-icon {
    height: 6.5vw;
  }
  .msg_content {
    .msg {
      width: 50%;
      height: 5.5vw;
      margin-top: -1vw;
      margin-top: 3vw;
    }
    .msg_content_intro {
      width: 45%;
      .msg-text {
        width: 85%;
      }
    }
  }
  .msg-input {
    display: none;
  }
  .msg-input-mobile {
    display: block;
  }
  .msg-icon-img {
    height: 5vw;
  }
  .bottom-img {
    width: 90%
  }
  .page-bottom {
    bottom: 0;
    margin-top: 3vw;
    position: fixed;
  }
}
.new-bottom {
  width: 100%;
  margin: 4vw 0 0 0;
  padding: 2vw 22vw;
  background: @lanmu;
  position: relative;
  box-sizing: border-box;
  td {
    line-height: 12px;
  }
}
.copyright {
  color: #8a8a90;
  font-weight: 800;
  font-size: 14px;
  font-family: fangsong;
}
.contact-info {
  color: #fff6c1;
  font-weight: 800;
  font-size: 16px;
  font-family: fangsong;
  margin-bottom: 10px;
}
.location-text {
  color: #bdbad6;
  font-weight: 800;
  font-size: 14px;
  font-family: fangsong;
  line-height: 14px;
}
.icon-td {
  width: 30px;
}
.anti {
  color: #bdbad6;
  font-weight: 500;
  font-size: 14px;
  font-family: fangsong;
  line-height: 14px;
  margin-top: 10px;
  width: 300px;
  text-align: right;
}
</style>





// WEBPACK FOOTER //
// src/components/Bottom.vue